import { create } from "zustand";

const UseTarifRibbonColor = create((set) => ({
  color: "#53545500",
  setColor: (color) => set({ color: color }),
}));

export default UseTarifRibbonColor;
